import { getGlobalObject } from '../../../tools/globalObject';
import { SessionPersistence } from '../sessionConstants';
import { getExpiredSessionState } from '../sessionState';
import { shallowClone } from '../../../tools/utils/objectUtils';
/**
 * Key used to store session state in the global object.
 * This allows RUM and Logs SDKs to share the same session when using memory storage.
 */
export var MEMORY_SESSION_STORE_KEY = '_DD_SESSION';
export function selectMemorySessionStoreStrategy() {
  return {
    type: SessionPersistence.MEMORY
  };
}
export function initMemorySessionStoreStrategy(configuration) {
  return {
    expireSession: function expireSession(sessionState) {
      return expireSessionFromMemory(sessionState, configuration);
    },
    isLockEnabled: false,
    persistSession: persistInMemory,
    retrieveSession: retrieveFromMemory
  };
}
function retrieveFromMemory() {
  var globalObject = getGlobalObject();
  if (!globalObject[MEMORY_SESSION_STORE_KEY]) {
    globalObject[MEMORY_SESSION_STORE_KEY] = {};
  }
  return shallowClone(globalObject[MEMORY_SESSION_STORE_KEY]);
}
function persistInMemory(state) {
  var globalObject = getGlobalObject();
  globalObject[MEMORY_SESSION_STORE_KEY] = shallowClone(state);
}
function expireSessionFromMemory(previousSessionState, configuration) {
  persistInMemory(getExpiredSessionState(previousSessionState, configuration));
}